<template lang="pug">
  .sidecart-wrapper
    transition(name="fade")
      .sidecart__overlay(v-if="sidecartOpen", @click="$store.dispatch('cart/closeSidecart')") 
    transition(name="off-canvas-right") 
      .sidecart(v-if="sidecartOpen")        
        .sidecart__main(:class="emptyClass")
          .sidecart__header
            h2.sidecart__title Review Your Bag ({{ totalItems }})
            icon-button.sidecart__close(icon="icon-close", size="20px", label="Close side cart", @click="$store.dispatch('cart/closeSidecart')")
          .sidecart__container
              .sidecart__contents-wrapper(v-if="totalItems > 0", key="content")
                .sidecart__contents.items-wrapper(:style="heightAutoStyle")
                  transition-group(name="slide-fade-down")                     
                    sidecart-line-item(                      
                      v-for="(item, index) in items",
                      :item="item",
                      :line="index + 1",
                      :order="items.length - index"
                      :key="item.id"
                    )
                  .sidecart__discount-summary(v-if="totalDiscount > 0") Total Discount: {{ totalDiscount | money }}
                  div.sidecart__discount__wrapper
                    div.sidecart__discount__wrapper__block.shippingContainer
                .sidecart__footer(:class="iOSDevice")
                  .sidecart__subtotal 
                    div.sidecart__subtotal--inner
                      p.p-s Subtotal 
                      p.p-s {{ totalPrice | money }}
                    p.caption-s.sidecart__subtotal--caption Shipping and taxes calculated at checkout
                  .sidecart__checkout
                    link-button.sidecart__view-cart.btn.btn-transparent(href="/cart", label="View Cart")
                    checkout-link-button.sidecart__checkout-cta.btn(href="/checkout", label="Checkout")                    
                .sidecart__footer-mobile-gap(:class="iOSDevice", v-if="$mq === 'mobile'")
              .sidecart__empty(v-else, key="empty") 
                div.sidecart__empty__container
                  p.sidecart__empty__message.p-m-m {{ emptyText }}
                  ul.sidecart__empty__collections                              
                    link-button-image(v-for="cta in collectionList" v-if="cta.label.length > 0" class="button--hollow" :href="cta.collection", :key="cta.label", :src="cta.image", :label="cta.label")
                .sidecart__empty-buttons(v-if="emptyCartCta === 'ctas'")
                  link-button(v-for="cta in ctas" v-if="cta.link.length > 0" class="button--hollow" :href="cta.link", :key="cta.link", :label="cta.text")
                gift-with-purchase-promo.sidecart__empty-gwp(v-else)
        .sidecart__main.related__products(v-if="totalItems === 0 && showRelatedProducts() ")
          .sidecart__related
            p.sidecart__related__title You May Also Like 
            div.sidecart__related__arrows
              div.sidecart__related__arrows--left(@click="previous()")
                svg(width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg")
                  circle(r="21" transform="matrix(-1 0 0 1 21 21)" fill="#3D3D3D")
                  path(d="m24 28-7-7 7-7" stroke="#fff")
              div.sidecart__related__arrows--right(@click="next()")
                svg(width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg")
                  circle(cx="21" cy="21" r="21" fill="#3D3D3D")
                  path(d="m18 28 7-7-7-7" stroke="#fff")
          .sidecart__productList 
            flickity(:options="flickityOptions", ref="flickity")
              sidecart-related-item(
                  v-for="(item, index) in shuffleProducts()",     
                  v-if="checkElement(item.variant_id, item)" 
                  :item="item", 
                  v-images-loaded="imgsLoaded", 
                  :key="item.id"
                )
          button.btn.sidecart__continue-shopping(@click="$store.dispatch('cart/closeSidecart')") Continue Shopping
</template>
 
<script>
  import { mapState } from 'vuex'
  import { gwpTypes } from '../../lib/config.gwp.js'
  import Flickity from 'vue-flickity'
  import IconButton from '../buttons/IconButton.vue'
  import CheckoutLinkButton from '../buttons/CheckoutLinkButton.vue'
  import LinkButton from '../buttons/LinkButton.vue'
  import LinkButtonImage from '../buttons/LinkButtonImage.vue'
  import SidecartRelatedItem from './SidecartRelatedItem.vue'
  import SidecartLineItem from './SidecartLineItem.vue'
  import { money, moneyWithoutTrailingZeros } from '../../filters/money.js';
  import imagesLoaded from 'vue-images-loaded'
  
  export default {
    name: 'Sidecart',
    components: { CheckoutLinkButton, LinkButton, IconButton, SidecartRelatedItem , SidecartLineItem , LinkButtonImage, Flickity },
    directives: { imagesLoaded },
    props: {
      showFreeShippingCalculator: Boolean,
      freeShippingAmount: Number,
      emptyText: String,
      ctas: Array,
      emptyCartCta: String,
      freeShippingText: String,
      returnText: String,
      continueLink: String,
      continueText: String,
      sidecartUpsellTitle: String,
      collectionList:  {
        type: Array,
        default: () => []
      },
      relatedProducts: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        relatedItems: [],
        loader: false,
        showShipping: false, 
        oldShippingValue: moneyWithoutTrailingZeros(this.freeShippingAmount),
        flickityOptions: {
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          cellAlign: 'left'
          // any options from Flickity can be used
        }
      }
    },
    computed: {
      ...mapState({
        allProducts: state => state.products.all,
        sidecartOpen: state => state.cart.sidecartOpen,
        items: state => state.cart.checkout.items,
        itemsReverse: state => state.cart.checkout.items.reverse(),
        itemsSubtotal: state => state.cart.checkout.items_subtotal_price,
        totalDiscount: state => state.cart.checkout.total_discount,
        totalPrice: state => state.cart.checkout.total_price,
        totalItems: state => state.cart.checkout.item_count,
        random: true,  
      }), 
      getSorteditems(){
        let arrayReverse = [];
        this.items.forEach(elem => {
          arrayReverse.splice(0, 0, elem)
        });

        return this.$mq != 'mobile' ? this.items : arrayReverse ;
      },
      heightAutoStyle() {
        let cartItems = this.items.length;
        let extra = cartItems > 1 ? 20 * cartItems : 0;  
        let height = 106 + (161 * cartItems) + extra;

        let spanWrapper = document.querySelector('.sidecart__contents.items-wrapper span');
        
        if(!!spanWrapper)
          spanWrapper.style.height = `${(141 * cartItems) + extra }px`;

        return `height: 100%;`;
      },
      emptyClass(){ //emptyClass noRelated
        if(this.totalItems < 1)
          return  'empty';
        if (this.totalItems > 0 && !this.showRelatedProducts()) 
          return 'no_related';
          
        return '' ;
      },
      iOSDevice() {
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
          if (iOS){
            return 'sidecart__ios';
          }
          else{
            return 'sidecart__reg';
          }
      }   
    },
    watch: {
      totalPrice (newVal, oldVal) {
      }, 
      items(newVal, oldVal){
       this.checkProductInCart(newVal)
      },
      sidecartOpen(newVal, oldVal){
        if(oldVal) {
          this.loader = newVal;
          this.showShipping = newVal;           
        }
        
        let body = document.querySelector('body');
        if(this.sidecartOpen){ 
          body.style.overflow = 'hidden'
        }else {
          body.style.overflow = ''
        } 
      }
    },
    updated: function(createElement) {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    },  
    methods: {
      imgsLoaded(instance, image) {
        // Reload flickity cells due to height change post
        let flickityInstance = this.$refs.flickity;
        flickityInstance.reloadCells();
      },
      setHeightBar(){
        let cartItems = this.items.length;
        let extra = cartItems > 1 ? 20 * cartItems : 0;  
        let spanWrapper = document.querySelector('.sidecart__contents.items-wrapper span');
        if(!!spanWrapper)
          spanWrapper.style.height = `${(141 * cartItems) + extra }px`;
      },
      afterAppearPromo(){
        this.setHeightBar();
        setTimeout(() => {
          this.loader = true;
        }, 600); 
      },              
      showRelatedProducts(){
        let result = this.relatedItems.filter( a => a.active == 'true'); 
        return result.length > 0;
      },      
      shuffleProducts() { 
        if(this.random){
          this.random = false; 
          let arrayResult = this.relatedItems.sort((a, b) => Math.random() > .5 ? -1 : 1);
          arrayResult = arrayResult.filter(el => el.active == 'true');
          if(arrayResult.length > 4)
            arrayResult = arrayResult.slice(0, 4);
          
          return arrayResult;
        }else{
          let arrayResult = this.relatedItems.filter(el => el.active == 'true');
          if(arrayResult.length > 4)
            arrayResult = arrayResult.slice(0, 4);
          return arrayResult; 
        } 
      },
      checkProductInCart(itemsCart){
        let self = this;
        this.relatedItems.forEach( (elem, index) => {
          let variant = elem.variant_id;
          itemsCart.forEach(e => {
            if (e.variant_id == variant){
              self.relatedItems[index].active = 'false';
            }
          }) 
        });
      },
      checkItems (itemsCart, variant){
        return itemsCart.find(e => e.variant_id == variant) ? false : true;
      },
      checkElement(variant, item) {        
        if(item.active == 'false')
          return false;          

        return this.items.filter(e => e.variant_id == variant).length > 0 ? false : true;
      },
      next() {
        this.$refs.flickity.next();
      },
      previous() {
        this.$refs.flickity.previous();
      }
    },
    created() {
      this.relatedItems = this.relatedProducts;
    }
  }
</script>

<style scoped lang="scss">
</style>
